module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/startup/startup.component.html
// module id = ./src/app/components/startup/startup.component.html
// module chunks = main